/**
 * Light Theme — production light theme definition.
 */

import type { Theme } from "./types";

export const lightTheme: Theme = {
  name: "light",

  colors: {
    text: {
      primary: "#333333",
      secondary: "#666666",
      muted: "#999999",
      disabled: "#999999",
      onDark: "#ffffff",
      link: "rgb(81, 131, 193)",
      content: "rgb(39, 86, 197)",
    },
    surface: {
      page: "rgb(250, 250, 250)",
      raised: "#ffffff",
      muted: "#eeeeef",
      panel: "#eeeeef",
      controls: "none",
      input: "#ffffff",
      white: "#ffffff",
      overlay: "rgba(51, 76, 96, 0.5)",
      subtle: "rgba(90, 111, 140, 0.1)",
      subtleHover: "rgba(90, 111, 140, 0.35)",
      highlight: "rgba(0, 126, 255, 0.08)",
      selected: "#bac6d1",
      hover: "rgba(0, 0, 0, 0.07)",
      disabled: "#eeeeef",
    },
    border: {
      default: "#cccccc",
      subtle: "#ddd",
      strong: "#5d5d5d",
      divider: "#b8c0c7",
      control: "#4d565f",
      focus: "rgb(81, 131, 193)",
    },
    interactive: {
      default: "#334c60",
      hover: "#2a3f50",
      muted: "#b9bfc5",
    },
    status: {
      success: "#2e7d32",
      error: "#dc5052",
      errorDark: "#DA3329",
      gold: "#D1B656",
      goldHover: "#d4a843",
    },
    brand: {
      dark: "#334c60",
      light: "#4686a3",
      accent: "#45c2ef",
    },
    nav: {
      background: "#243744",
      surface: "#374A55",
      secondary: "rgb(137, 166, 202)",
      hover: "#2a3f50",
    },
    footer: {
      bg: "#5a708c",
    },
  },

  shadow: {
    none: "none",
    sm: "0 1px 3px rgba(0, 0, 0, 0.1)",
    base: "0px 0px 5px 0px rgba(0, 0, 0, 0.15)",
    md: "0px 2px 15px rgba(0, 0, 0, 0.12)",
    lg: "0 0 9px 1px rgba(0, 0, 0, 0.28)",
  },
};
